RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.UnknownListItem = views.ContentListItem.extend({
        template: '#contentUnknownListItemTemplate',
        isUnknownListItem: true
    });

});
